// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2019 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.mac {
  --theia-ui-font-family: -apple-system,BlinkMacSystemFont,sans-serif
}

.mac:lang(zh-Hans) {
  --theia-ui-font-family: -apple-system,BlinkMacSystemFont,PingFang SC,Hiragino Sans GB,sans-serif
}

.mac:lang(zh-Hant) {
  --theia-ui-font-family: -apple-system,BlinkMacSystemFont,PingFang TC,sans-serif
}

.mac:lang(ja) {
  --theia-ui-font-family: -apple-system,BlinkMacSystemFont,Hiragino Kaku Gothic Pro,sans-serif
}

.mac:lang(ko) {
  --theia-ui-font-family: -apple-system,BlinkMacSystemFont,Nanum Gothic,Apple SD Gothic Neo,AppleGothic,sans-serif
}

.windows {
  --theia-ui-font-family: Segoe WPC,Segoe UI,sans-serif
}

.windows:lang(zh-Hans) {
  --theia-ui-font-family: Segoe WPC,Segoe UI,Microsoft YaHei,sans-serif
}

.windows:lang(zh-Hant) {
  --theia-ui-font-family: Segoe WPC,Segoe UI,Microsoft Jhenghei,sans-serif
}

.windows:lang(ja) {
  --theia-ui-font-family: Segoe WPC,Segoe UI,Yu Gothic UI,Meiryo UI,sans-serif
}

.windows:lang(ko) {
  --theia-ui-font-family: Segoe WPC,Segoe UI,Malgun Gothic,Dotom,sans-serif
}

.linux {
  --theia-ui-font-family: system-ui,Ubuntu,Droid Sans,sans-serif
}

.linux:lang(zh-Hans) {
  --theia-ui-font-family: system-ui,Ubuntu,Droid Sans,Source Han Sans SC,Source Han Sans CN,Source Han Sans,sans-serif
}

.linux:lang(zh-Hant) {
  --theia-ui-font-family: system-ui,Ubuntu,Droid Sans,Source Han Sans TC,Source Han Sans TW,Source Han Sans,sans-serif
}

.linux:lang(ja) {
  --theia-ui-font-family: system-ui,Ubuntu,Droid Sans,Source Han Sans J,Source Han Sans JP,Source Han Sans,sans-serif
}

.linux:lang(ko) {
  --theia-ui-font-family: system-ui,Ubuntu,Droid Sans,Source Han Sans K,Source Han Sans JR,Source Han Sans,UnDotum,FBaekmuk Gulim,sans-serif
}

.mac {
  --monaco-monospace-font: "SF Mono",Monaco,Menlo,Courier,monospace
}

.windows {
  --monaco-monospace-font: Consolas,"Courier New",monospace
}

.linux {
  --monaco-monospace-font: "Ubuntu Mono","Liberation Mono","DejaVu Sans Mono","Courier New",monospace
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/os.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF","sourcesContent":["/********************************************************************************\n * Copyright (C) 2019 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.mac {\n  --theia-ui-font-family: -apple-system,BlinkMacSystemFont,sans-serif\n}\n\n.mac:lang(zh-Hans) {\n  --theia-ui-font-family: -apple-system,BlinkMacSystemFont,PingFang SC,Hiragino Sans GB,sans-serif\n}\n\n.mac:lang(zh-Hant) {\n  --theia-ui-font-family: -apple-system,BlinkMacSystemFont,PingFang TC,sans-serif\n}\n\n.mac:lang(ja) {\n  --theia-ui-font-family: -apple-system,BlinkMacSystemFont,Hiragino Kaku Gothic Pro,sans-serif\n}\n\n.mac:lang(ko) {\n  --theia-ui-font-family: -apple-system,BlinkMacSystemFont,Nanum Gothic,Apple SD Gothic Neo,AppleGothic,sans-serif\n}\n\n.windows {\n  --theia-ui-font-family: Segoe WPC,Segoe UI,sans-serif\n}\n\n.windows:lang(zh-Hans) {\n  --theia-ui-font-family: Segoe WPC,Segoe UI,Microsoft YaHei,sans-serif\n}\n\n.windows:lang(zh-Hant) {\n  --theia-ui-font-family: Segoe WPC,Segoe UI,Microsoft Jhenghei,sans-serif\n}\n\n.windows:lang(ja) {\n  --theia-ui-font-family: Segoe WPC,Segoe UI,Yu Gothic UI,Meiryo UI,sans-serif\n}\n\n.windows:lang(ko) {\n  --theia-ui-font-family: Segoe WPC,Segoe UI,Malgun Gothic,Dotom,sans-serif\n}\n\n.linux {\n  --theia-ui-font-family: system-ui,Ubuntu,Droid Sans,sans-serif\n}\n\n.linux:lang(zh-Hans) {\n  --theia-ui-font-family: system-ui,Ubuntu,Droid Sans,Source Han Sans SC,Source Han Sans CN,Source Han Sans,sans-serif\n}\n\n.linux:lang(zh-Hant) {\n  --theia-ui-font-family: system-ui,Ubuntu,Droid Sans,Source Han Sans TC,Source Han Sans TW,Source Han Sans,sans-serif\n}\n\n.linux:lang(ja) {\n  --theia-ui-font-family: system-ui,Ubuntu,Droid Sans,Source Han Sans J,Source Han Sans JP,Source Han Sans,sans-serif\n}\n\n.linux:lang(ko) {\n  --theia-ui-font-family: system-ui,Ubuntu,Droid Sans,Source Han Sans K,Source Han Sans JR,Source Han Sans,UnDotum,FBaekmuk Gulim,sans-serif\n}\n\n.mac {\n  --monaco-monospace-font: \"SF Mono\",Monaco,Menlo,Courier,monospace\n}\n\n.windows {\n  --monaco-monospace-font: Consolas,\"Courier New\",monospace\n}\n\n.linux {\n  --monaco-monospace-font: \"Ubuntu Mono\",\"Liberation Mono\",\"DejaVu Sans Mono\",\"Courier New\",monospace\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
